export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'promo-codes',
      displayName: 'menu.promoCodes',
      meta: {
        icon: 'sell',
      },
    },
    {
      name: 'partners',
      displayName: 'menu.partners',
      meta: {
        icon: 'handshake',
      },
    },
    {
      name: 'utm-builder',
      displayName: 'menu.utmBuilder',
      meta: {
        icon: 'link',
      },
    },
    {
      name: 'finance',
      displayName: 'menu.finance',
      meta: {
        icon: 'payments',
      },
    },
  ] as INavigationRoute[],
}
